module.exports = __webpack_public_path__ + "img/thumbnail_RedRiverHog_m_normal.05dc75c1.png";